import './Rajasthan.css'
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";

export const RihandDam=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Rihand Dam</h1>
           <p className="sub-heading">Largest dam of India by volume</p>
         </div>
         <div className="description">
         Rihand Dam, also known as Govind Ballabh Pant Sagar, is a concrete gravity dam located at Pipri in Sonbhadra District in Uttar Pradesh, Its reservoir area is on the border of Madhya pradesh and Uttar Pradesh. It is on the Rihand River which is the tributary of the Son River. The catchment area of this dam is spread in Uttar Pradesh, Madhya Pradesh & Chhattisgarh whereas it supplies irrigation water in Bihar located in the downstream of the river. Rihand dam is a concrete gravity dam with a length of 934.21 m. The maximum height of the dam is 91.44 m and was constructed during period 1954-62. The dam comprises 61 independent blocks and ground joints. The powerhouse is situated at the toe of the dam, with installed capacity of 300 MW (6 units of 50 MW each). The Intake Structure is situated between blocks no. 28 to 33. The Dam is in distress condition. It is proposed to carry out the rehabilitation works in the dam and the powerhouse. The F.R.L. of the dam is 268.22 m and it impounds 8.6 Million Acre ft of water. It is one of the biggest reservoir by its gross storage capacity in India but sufficient water is not flowing in to the reservoir. The construction of the dam resulted in forced relocation of nearly 100,000 people Many super thermal power stations are located in the catchment area of the dam. These are Singrauli, Vindyachal, Rihand, Anpara & Sasan super thermal power stations and Renukoot thermal station. The high alkalinity run off water from the ash dumps (some are located in the reservoir area) of these coal-fired power stations ultimately collects in this reservoir enhancing its water alkalinity and pH. Using high alkalinity water for irrigation converts the agriculture fields in to fallow Alkali soils.</div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Rihand Dam/dam1.jpeg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Rihand Dam/dam2.jpeg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Rihand Dam/dam3.jpeg')}
               alt="Mukha Fall 3"
               className="gallery-image"
             />
             {/* <p className="image-caption">The lush green surroundings of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Rihand Dam/dam4.jpeg')}
               alt="Mukha Fall 4"
               className="gallery-image"
             />
             {/* <p className="image-caption">The tranquil ambiance at sunset.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Rihand Dam/dam5.jpeg')}
               alt="Mukha Fall 5"
               className="gallery-image"
             />
             {/* <p className="image-caption">A panoramic view of Mukha Fall's beauty.</p> */}
           </div>
         </div>
   
         <BookSection />
       </div>
     );
};